import { Avatar, Badge, Button } from '@radix-ui/themes';
import { Link, useNavigate } from 'react-router-dom';
import { currentUser } from 'helpers/authentication';
import { timeOptions } from 'helpers/formatTime';
import { markNotificationAsRead } from 'store/notifications/notificationsSlice';
import { selectProfile } from 'store/profileSelector/profileSelectorSlice';
import { useAppDispatch } from 'store/store';
import type { NotificationType } from 'types/notification';
import type { ProfileType } from 'types/user';

export const Notification: React.FC<{ notification: NotificationType }> = ({ notification }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const notificationContent = (notification: NotificationType) => {
    const date = new Date(notification.created_at * 1000);

    return (
      <div className='flex flex-col'>
        <div className='mr-1 text-sm font-light'>{date.toLocaleDateString('it', timeOptions)}</div>
        <div className='content'>{notification.content}</div>
      </div>
    );
  };

  const changeProfileAndRedirect = (notification: NotificationType) => {
    const profileIndex = currentUser().available_profiles.findIndex(
      (profile: ProfileType) => profile.type === notification.extra_profile_type_destination,
    );
    dispatch(selectProfile(profileIndex));
    navigate(notification.destination_url);
  };

  const onClickFn = () => {
    const notificationId = notification.id;
    dispatch(markNotificationAsRead(notificationId));
  };
  const renderNotification = (notification: NotificationType) => {
    const content = notificationContent(notification);

    return (
      <div
        id='systemNotification'
        className='bg-neutral-neutral-2 hover:bg-neutral-neutral-3 flex w-full max-w-full flex-1 items-start justify-between gap-2 rounded-md px-2 py-2'
        key={notification.id}
      >
        {notification.extra_profile_type_destination ? (
          <Button size='2' color='lime' onClick={() => changeProfileAndRedirect(notification)}>
            {content}
          </Button>
        ) : notification.thumbnail ? (
          <>
            <Link
              className='text-neutral-neutral-10 text-base font-medium'
              to={notification.destination_url}
              onClick={onClickFn}
            >
              <div id='top' className='flex w-full items-start justify-between'>
                <div id='playerinfo' className='flex items-center gap-2 p-2'>
                  <div id='avatar' className='flex h-8 w-8 items-center gap-2 self-stretch fill-transparent'>
                    <Avatar
                      alt='Avatar Utente'
                      className='flex h-8 w-8 rounded-md'
                      src={notification?.thumbnail!}
                      fallback={<img src='/images/player-avatar.jpg'></img>}
                    />
                  </div>
                  <div id='nome' className='flex grow items-center self-stretch'>
                    <div className='truncate, text-neutral-neutral-12 text-base font-medium'>{content}</div>
                  </div>
                </div>
              </div>
            </Link>
            {notification.new_one && (
              <div className='flex justify-end'>
                <div id='badge' className='mr-3 flex h-2 w-2'>
                  <Badge size='1' variant='solid' color='ruby' className='p-2' radius='large'></Badge>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <Link
              className='text-neutral-neutral-10 text-base font-medium'
              to={notification.destination_url}
              onClick={onClickFn}
            >
              {content}
            </Link>
            {notification.new_one && (
              <div id='badge' className='mr-3 flex h-2 w-2'>
                <Badge size='1' variant='solid' color='ruby' className='p-2' radius='large'></Badge>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  return renderNotification(notification);
};

export default Notification;
